import { createContext } from "react";

import { Workbench } from "@pages/editor/stores";

interface WorkbenchContextProps {
  workbench: Workbench;
}

export const WorkbenchContext = createContext<WorkbenchContextProps>(
  undefined!
);
